import { Button as CMSButton, Spinner } from '@cmsgov/ds-medicare-gov';
import * as PropTypes from 'prop-types';
import React from 'react';
import { buttonClick, linkClick } from '../analytics';
import cloneObject from '../functions/clone.object';

const Button = props => {
   let classNames = '';
   let size = null;
   if (props.displayAs === 'link') {
      classNames += ' ds-c-button--transparent ';
      if (props.color === 'teal')
         classNames += ' ds-c-button--primary ';
      else if (props.color === 'blue')
         classNames += ' ds-c-button--primary-alt ';
      else
         classNames += ' ds-c-button--inverse ';
      
   } else if (props.displayAs === 'button') {
      if (props.size === 'big')
         size = 'big';
      if (props.color === 'teal')
         classNames += props.fill === 'outlined' ? ' ds-c-button--primary-outline ' : ' ds-c-button--primary ';
      else if (props.color === 'blue')
         classNames += props.fill === 'outlined' ? ' ds-c-button--primary-alt-outline ' : ' ds-c-button--primary-alt ';
      
   }
   let buttonProps = cloneObject(props);
   delete buttonProps.displayAs;
   delete buttonProps.isDisabled;
   delete buttonProps.size;
   delete buttonProps.onClick
   delete buttonProps.analyticsDescription;
   delete buttonProps.isLoading;

   const onClickWithAnalytics = e => {
      const text = e.currentTarget.textContent.trim();
      if (props.displayAs === 'link') {
         linkClick(text, props.analyticsDescription);
      } else {
         buttonClick(text, props.analyticsDescription);
      }
      props.onClick(e);
   }

   return <>
      <CMSButton
         className={classNames}
         disabled={props.isDisabled}
         size={size}
         onClick={onClickWithAnalytics}
         {...buttonProps}
      >
         {props.isLoading &&
         <Spinner className="ds-u-margin-right--1"/>}
         {props.children}
      </CMSButton>
   </>;
}

Button.propTypes = {
   color: PropTypes.oneOf(['teal', 'blue', 'white']).isRequired,
   displayAs: PropTypes.oneOf(['button', 'link']).isRequired,
   fill: PropTypes.oneOf(['solid', 'outlined', '']),
   isDisabled: PropTypes.bool,
   size: PropTypes.oneOf(['big', 'small']),
   isLoading: PropTypes.bool,
   // description of what button does for analytics - should be an href if button navigates to a url
   analyticsDescription: PropTypes.string
};

Button.defaultProps = {
   fill: '',
   isDisabled: false,
   size: 'big',
};

export default Button;